import {
  PlanInternalMessage,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { CardHeader } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/CardHeader";
import { EventBadges } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/EventBadges";
import { InternalMessageBox } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/InternalMessageBox";
import { useEventSeenStatus } from "features/CenterContent/RoleContent/EventHandling/components/eventCard/useEventSeenStatus";
import { EventCardShell } from "features/CenterContent/RoleContent/EventHandling/components/shared/EventCardShell";
import { FC } from "react";
import { Text } from "shared/components/Spor";
import { TrainOperationalInformationOverviewResponse } from "shared/types/operationalInformation";

type TrainEventCardProps = {
  event: TrainOperationalInformationOverviewResponse;
  internalMessages: PlanInternalMessage[];
  columnEventState?: PlanMeasureKey;
};

const TrainEventCard: FC<TrainEventCardProps> = ({
  event,
  internalMessages,
  columnEventState,
}) => {
  useEventSeenStatus(event.uuid, event.version);

  return (
    <EventCardShell
      event={event}
      eventInternalMessages={internalMessages}
      columnEventState={columnEventState}
      eventTitle={event.trainIdentifier?.identifier || ""}
    >
      {({
        colorScheme,
        semantics,
        notifying,
        canToggleNotify,
        onToggleNotify,
      }) => (
        <>
          <CardHeader
            title={
              <>
                <b>{event.trainIdentifier?.identifier ?? "-"}</b>{" "}
                {event.lineNumber ?? "-"}
              </>
            }
            colorScheme={colorScheme}
            semantics={semantics}
            notifying={notifying}
            onToggleNotify={onToggleNotify}
            showNotifyButton={canToggleNotify}
          />

          <EventBadges
            eventType={event.type.type}
            eventLabel={event.type.label ?? event.type.type}
            state={event.state}
          />

          {event.action?.description?.NOB && (
            <Text
              variant="sm"
              color={colorScheme.textColorSecondary}
              fontWeight="normal"
            >
              {event.action.description.NOB}
            </Text>
          )}

          <InternalMessageBox
            messages={internalMessages}
            semantics={semantics}
            colorScheme={colorScheme}
          />
        </>
      )}
    </EventCardShell>
  );
};

export default TrainEventCard;
